// Known dial codes (sorted by length desc so longer ones win).
const DIAL_CODES = [
  "971","966","880","977","254","234","974","672","673","675","676","677","678","679","680","681","682","683","685","686","687","688","689","690","691","692",
  "850","852","853","855","856","886","960","961","962","963","964","965","967","968","970","972","973","975","976","992","993","994","995","996","998",
  "20","27","30","31","32","33","34","36","39","40","41","43","44","45","46","47","48","49","51","52","53","54","55","56","57","58","60","61","62","63","64","65","66","81","82","84","86","90","91","92","93","94","95","98",
  "1","7"
];

/** Format a stored phone (E.164 like "+919999999999" OR legacy "9999999999") for display. */
export function formatPhone(phone) {
  if (!phone) return "";
  const p = String(phone).trim();
  if (p.startsWith("+")) {
    const digits = p.slice(1);
    for (const dc of DIAL_CODES) {
      if (digits.startsWith(dc) && digits.length > dc.length) {
        return `+${dc} ${digits.slice(dc.length)}`;
      }
    }
    return p;
  }
  // Legacy storage — assume India.
  return `+91 ${p}`;
}

/** Strip the leading "+" — useful for SDKs that expect dial+national without "+". */
export function phoneDigitsOnly(phone) {
  return String(phone || "").replace(/\D/g, "");
}
